// @ts-strict

import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { IPPIImgFieldValue } from '@app/core/services/url-address-config/url-address-config.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-download-buttons-modal',
  templateUrl: './download-buttons-modal.component.html',
  styleUrls: ['./download-buttons-modal.component.scss']
})
export class DownloadButtonsModalComponent {
  @Input() configurationData?: IPPIImgFieldValue[];
  @ViewChild('buttonList') buttonListRef?: ElementRef<HTMLDivElement>;
  scrolledToBottom = false;

  constructor(private activeModal: NgbActiveModal) {}

  getValue(button: IPPIImgFieldValue): void {
    this.activeModal.close(button);
  }

  public checkIfScrolled(): void {
    const scrollContainer = this.buttonListRef?.nativeElement;

    this.scrolledToBottom = scrollContainer ? scrollContainer.scrollTop === scrollContainer.scrollHeight - scrollContainer.clientHeight : false;
  }
}
